import { OfficeBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/officeBlock/officeBlock.layout'
import { StyleguideExample, StyleguidePart } from '@shared/Hoppinger.Styleguide/Frontend'
import * as React from 'react'
import { dummyData } from '../../../config/dummyData'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsOfficeBlock = () => (
  <>
    <StyleguidePart title="Default" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentOfficeBlock />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentOfficeBlock = (props: { nested?: boolean }) => (
  <OfficeBlockLayout
    nested={props.nested || false}
    id="office-block-example"
    title="Offices"
    intro={dummyData.intro}
    body="<p>Quis gravida magna mi a <b>libero</b>. Fusce vulputate eleifend sapien.</p>"
    address={{
      title: 'Head Office',
      visiting: {
        address: 'Dummy Address',
        street: 'Dummy Street 123',
        code: '12345 AB',
        city: 'Dummy City',
        country: 'Dummy Country',
        mapLink: { ...dummyData.primaryUpdater, title: 'How to get there?' }
      },
      postal: {
        address: 'Dummy Postal Address',
        street: 'Dummy Postal Street',
        code: '54321 BA',
        city: 'Dummy Postal City',
        country: 'Dummy Postal Country'
      }
    }}
    contact={{
      title: 'Contact Us',
      email: ['dummy@example.com', 'example@dummy.com'],
      telephone: ['123-4567 890', '+31 (0)98-76 54 321'],
      fax: ['123-4567 890'],
      website: { ...dummyData.primaryUpdater, title: 'dummywebsite.com' }
    }}
  />
)
